<template>
    <section class="home-container">
        <MasterPage title="病历管理">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="8">
                        <FormItem label="患者用户：">
                            <Select v-model="select.userId" clearable  placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="病历名称：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="病历状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增病历" width="60%" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Row>
                    <Col span="12">
                    <FormItem label="病历名称：">
                        <Input v-model="itemAdd.name" placeholder="请输入" />
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="病历患者：">
                        <Select v-model="itemAdd.userId" transfer placeholder="请选择">
                            <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div style="line-height: 50px">病历内容：</div>
            <div id="editor"></div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改病历" width="60%" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Row>
                    <Col span="12">
                    <FormItem label="病历名称：">
                        <Input v-model="updateInfoItem.name" placeholder="请输入" />
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="病历患者：">
                        <Select v-model="updateInfoItem.userId" transfer placeholder="请选择">
                            <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div style="line-height: 50px">病历内容：</div>
            <div id="editorUpdate"></div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="病历详情">
            <Form :label-width="100">
                <FormItem  label="病历名称：">
                    {{infoItem.name}}
                </FormItem>
                <FormItem label="病历患者：">
                    <span v-for="item in userAllList" :key="item.id" v-if="item.id === infoItem.userId">{{item.name}}</span>
                </FormItem>
            </Form>
            <div style="line-height: 50px">病历内容：</div>
            <div v-html="infoItem.content"></div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    var E = require('wangeditor')
    import {baseURL} from '../../json/common'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '病历名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '患者用户',
                        tooltip:true,
                        align: 'center',
                        render:(h, params) =>{
                            for (let i in this.userAllList) {
                                if (this.userAllList[i].id == params.row.userId) {
                                    return h("span",this.userAllList[i].name)
                                }
                            }
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                // Buttons.push(
                                //     h('Button', {
                                //         props: {
                                //             type: 'primary',
                                //             icon:'md-unlock',
                                //             label:"small",
                                //         },
                                //         style: {
                                //             marginRight: '5px'
                                //         },
                                //         on: {
                                //             click: () => {
                                //                 this.reuseItem_modal(this.dataList[params.index])
                                //             }
                                //         }
                                //     }, '启用')
                                // )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '删除')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                userAllList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    userId: '',
                    name:'',
                    isDeleted:'false',
                },
                itemAdd:{
                    userId: '',
                    name:'',
                    content: ''
                },
                updateInfoItem:"",
                infoItem:'',
                editor:null,
                editorUpdate:null,
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                baseURL:baseURL,
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
        },
        mounted(){
            let editor = new E('#editor')
            editor.customConfig.uploadImgShowBase64 = true
            let menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'strikeThrough',  // 删除线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'list',  // 列表
                'justify',  // 对齐方式
                'quote',  // 引用
                'emoticon',  // 表情
                'image',  // 插入图片
                'table',  // 表格
                'undo',  // 撤销
                'redo'  // 重复
            ]
            editor.customConfig.uploadImgShowBase64 = true
            editor.customConfig.menus = menus
            editor.customConfig.uploadImgMaxSize = 64 * 1024
            editor.customConfig.uploadImgServer = 'food/file/upload'
            editor.customConfig.uploadFileName = 'file'
            editor.customConfig.uploadImgHooks = {
                customInsert: (insertImg, result, editor) => {
                    insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
                }
            }
            editor.create()
            this.editor = editor

            let editorUpdate = new E('#editorUpdate')
            editorUpdate.customConfig.uploadImgShowBase64 = true
            editorUpdate.customConfig.menus = menus
            editorUpdate.customConfig.uploadImgMaxSize = 64 * 1024
            editorUpdate.customConfig.uploadImgServer = 'food/file/upload'
            editorUpdate.customConfig.uploadFileName = 'file'
            editorUpdate.customConfig.uploadImgHooks = {
                customInsert: (insertImg, result, editor) => {
                    insertImg(this.baseURL +  result.data.replace(/\\/g,"/"))
                }
            }
            editorUpdate.create()
            this.editorUpdate = editorUpdate
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('case/list',{
                    name:this.select.name,
                    userId:this.select.userId === undefined?'':this.select.userId,
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'病历列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.userId.length <= 0){
                    return this.$Message.warning('请选择患者用户');
                }
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入病历名称');
                }
                this.itemAdd.content = this.editor.txt.html();
                if (this.itemAdd.content.length <= 0){
                    return this.$Message.warning('请输入病历内容');
                }
                this.addLoading = true
                this.$http.post('case/add',{
                    content: this.itemAdd.content,
                    userId: this.itemAdd.userId,
                    name: this.itemAdd.name,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '病历新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'病历新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.editorUpdate.txt.html(item.content)
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.userId.length <= 0){
                    return this.$Message.warning('请选择患者用户');
                }
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入病历名称');
                }
                this.updateInfoItem.content = this.editorUpdate.txt.html();
                if (this.updateInfoItem.content.length <= 0){
                    return this.$Message.warning('请输入病历内容');
                }
                this.updateLoading = true
                this.$http.post('case/update',{
                    id: this.updateInfoItem.id,
                    content: this.updateInfoItem.content,
                    userId: this.updateInfoItem.userId,
                    name: this.updateInfoItem.name,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '病历修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'病历修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd.userId = this.itemAdd.name = this.itemAdd.center = ''
                this.editor.txt.clear()
                this.editorUpdate.txt.clear()
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            // reuseItem_modal(item){
            //     this.$Modal.confirm({
            //         title: '确认启用病历“'+ item.name + '”',
            //         loading:true,
            //         onOk: () => {
            //             this.reuseItem(item);
            //         }
            //     });
            // },
            // reuseItem(item){
            //     this.$http.post('case/reuse',{
            //         id:item.id,
            //     }).then(function (res) {
            //         this.$Modal.remove()
            //         let msg = res.body
            //         if (msg.success) {
            //             this.$Notice.success({title: '病历启用成功'});
            //             this.pageFindItem()
            //         }else {
            //             this.$Notice.error({title:'病历启用失败',desc: msg.message});
            //         }
            //     },function (res) {
            //         this.$Modal.remove()
            //         this.myError(res.body)
            //     })
            // },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认删除病历“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('case/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '病历删除成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'病历删除失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


